/**
 * Custom directive to detect when the visibility of an element changes
 * @example <div v-observe-visibility="isVisible => handleVisibility(isVisible)"></div>
 */
export default {
  beforeMount(el, binding) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const isVisible = entry.isIntersecting;
        // Emit the visibility state of the element
        binding.value(isVisible, observer);
      });
    });

    observer.observe(el);
    el._visibilityObserver = observer;
  },
  beforeUnmount(el) {
    if (el._visibilityObserver) {
      // Remove the observer when the component is unmounted
      el._visibilityObserver.unobserve(el);
      el._visibilityObserver.disconnect();
    }
  },
};
